import clsx from "clsx";
import { forwardRef, VideoHTMLAttributes } from "react";
import classes from "./video-player.module.css";

export type VideoPlayerProps = VideoHTMLAttributes<HTMLVideoElement> & {
  src: string;
  description?: string;
};

export const VideoPlayer = forwardRef<HTMLVideoElement, VideoPlayerProps>(
  ({ className, description, src, ...props }, ref) => {
    return (
      <video
        ref={ref}
        className={clsx(classes.root, className)}
        aria-description={description}
        data-testid="video-player"
        {...props}
      >
        <source type="video/mp4" src={src} />
        <track kind="captions" />
      </video>
    );
  },
);

VideoPlayer.displayName = "VideoPlayer";
